export const MAX_ALLOWED_FILES_PER_SECTION = 25;
export const MAX_ALLOWED_FILES_PER_DOCUMENT = 20;
export const DEFAULT_PAGE_SIZE = 10;
export const DAYJS_ISO_DATE_FORMAT = 'YYYY-MM-DD';
